import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import EvnVar from '../../EnvVar'
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import citiesOptions from './cityOptions.json'

const baseURL = EvnVar()

function RegistrationForm() {
    const citiesNames = citiesOptions
    const reCaptchKey = "6LdPlwEqAAAAAJW8_fGErUeO54kZPmKv8ZA86QzZ";
    const [recaptchaToken, setRecaptchaToken] = useState(null)
    const [formData, SetFormData] = useState({
        category: 'true',
        membership: '',
        registration: '',
        city: 'Kanpur',
        cityId: 49,
        dob: ''
    })

    const navigate = useNavigate();

    const handleChangeRecaptcha = (value) => {
        setRecaptchaToken(value);
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        // const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        // const yearPattern = /^\d{4}/;
        const updatedFormData = {
            ...formData,
            [name]: value

        }

        // if (name === 'membership') {
        //     updatedFormData.membership = value.replace(/\D/g, '').slice(0, 10);
        // }

        // if (name === 'registration') {
        //     // const sixNumericDigit = value.replace(/[^0-9]/gi, '').slice(0, 6);
        //     // const sixAlphaDigit = value.replace(/[^a-z]/gi, '').slice(0, 4);
        //     // updatedFormData.registration = sixNumericDigit + sixAlphaDigit

        //     updatedFormData.registration = value.replace(/[^0-9a-zA-Z]/g, '').slice(0, 15);
        // }

        if (name === 'city') {
            const cityId = e.target.selectedOptions[0].id;
            // console.log("cityId", cityId);
            updatedFormData.cityId = cityId; // Add cityId to the formData if needed
        }

        SetFormData(updatedFormData)
    }

    const [loader, setLoader] = useState(false)
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoader(true)
        // console.log('Form Data Submitted:', formData);

        let rnumber = formData.category === "true" || formData.category === "branch" ? formData.membership : formData.registration

        const userData = JSON.stringify(
            {
                "isCA": formData.category,
                "rnumber": rnumber,
                "city": formData.city,
                "dob": formData.dob,
                "branchid": formData.cityId,
                "recaptcha": recaptchaToken
            }
        )

        console.log('Sending to api:', JSON.parse(userData));


        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/auth/register`,
            headers: {
                'content-type': 'application/json'
            },
            data: userData,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                setRecaptchaToken(null)
                navigate('/ambassador/login')
                setLoader(false)
            })
            .catch((error) => {
                console.log("Failed to Registration", error);
                setLoader(false)
                alert(error.response.data.error)
            })
    }

    return (
        <div className='row'>
            <div className='col-lg-12 m-auto'>
                <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-lg-6">
                        <label htmlFor="category" className="form-label">Category (Chartered Accountant/Student/Branch)</label>
                        <select className="form-select" aria-label="Default select example" name="category" id="category" value={formData.category} required onChange={handleChange}>
                            <option value="true">Chartered Accountant</option>
                            <option value="false">Student</option>
                            <option value="branch">Branch</option>
                        </select>
                    </div>
                    {formData.category != "false" ?
                        <div className="col-lg-6">
                            <label htmlFor="membership" className="form-label">ICAI Membership Number (for CAs)</label>
                            <input type="text" className="form-control" name="membership" id="membership" value={formData.membership} required onChange={handleChange} placeholder="Membership Number" />
                        </div> :
                        <div className="col-lg-6">
                            <label htmlFor="registration" className="form-label">Student Registration Number (for students)</label>
                            <input type="text" className="form-control" name="registration" id="registration" value={formData.registration} required onChange={handleChange} placeholder="Registration Number" />
                        </div>}
                    <div className="col-lg-6">
                        <label htmlFor="city" className="form-label">
                            City</label>
                        {/* <input type="text" className="form-control" id="city" placeholder="City" value={formData.city} required onChange={handleChange} /> */}
                        <select id={formData.cityId} name='city' value={formData.city} onChange={handleChange} required>
                            {citiesNames && citiesNames.map((value, index) => (
                                <option id={value.id} value={value.cityName} key={index}>{value.cityName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-lg-6">
                        <label htmlFor="dob" className="form-label">
                            Date of Birth</label>
                        <input type="date" name='dob' className="form-control" id="dob" placeholder="Date of birth" value={formData.dob} required onChange={handleChange} min="1900-01-01" max="2023-12-31" />
                    </div>
                    <div className="col-lg-6">
                        <ReCAPTCHA
                            sitekey={reCaptchKey}
                            onChange={handleChangeRecaptcha}
                        />
                    </div>
                    <div className="col-lg-12">
                        <div className='form-check mb-3 d-flex align-items-start'>
                            <input style={{ width: "1.5rem", height: "1.5rem", padding: "0", display: "flex", alignItems: "center", marginRight: "0.75rem", marginTop: "0" }} id='decleration' className='form-check-input' type="checkbox" required />
                            <label htmlFor='decleration' className="form-check-label">By registering, I agree to the ICAI Terms of Service and Privacy Policy. I understand that ICAI is not responsible for my actions on this platform. The views expressed by the Ambassador during any session The Institute of Chartered Accountants of India may not necessarily subscribe to the views expressed by the Ambassador(s).</label>
                        </div>
                        {loader && loader ? <button type="submit" className="btn btn-primary" disabled>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Sign in
                        </button> : <button type="submit" className="btn btn-primary">Sign in</button>}
                        <p className='mt-3'><Link to="/ambassador/login">Already have account, click here for login</Link></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default RegistrationForm
